import anime from "animejs/lib/anime.es.js";

export const handleHeader = () => {
  const header = document.querySelector('[header="root"]');
  if (!header || document.querySelector(".js-header__intersection")) return false;
  const body = header.querySelector('[header="body"]');
  if (!body) return false;
  const logo = header.querySelector('[header="logo"]');
  const intersectionEl = document.createElement("div");
  const fixedClass = "js-header__body--fixed";

  const animeOptions = {
    delay: 0,
    duration: 250,
    easing: "easeInOutQuad",
  };

  const handleInAnimation = () => {
    if (!body.classList.contains(fixedClass)) return false;
    anime({
      ...animeOptions,
      targets: body,
      opacity: [1, 0],
      complete: () => {
        body.classList.remove(fixedClass);
        anime({
          ...animeOptions,
          // ロゴがない場合がある
          targets: [body, logo ? logo : ""],
          opacity: [0, 1],
        });
      },
    });

    return false;
  };

  const handleOutAnimation = () => {
    body.classList.add(fixedClass);
    anime({
      ...animeOptions,
      targets: body,
      opacity: [0, 1],
    });

    // ロゴがない場合がある
    if (logo) {
      anime({
        ...animeOptions,
        targets: logo,
        opacity: [1, 0],
      });
    }

    return false;
  };

  const callback = (entries) => {
    entries.forEach((entry) => {
      entry.isIntersecting ? handleInAnimation() : handleOutAnimation();
    });
  };

  const observerOptions = {
    rootMargin: "0px",
    threshold: 0,
  };

  const observer = new IntersectionObserver(callback, observerOptions);

  intersectionEl.classList.add("js-header__intersection");
  header.appendChild(intersectionEl);
  observer.observe(intersectionEl);

  return false;
};
